import React, { useEffect, useRef, useState } from "react";
import Divider from "../components/Divider";
import { Container, Row, Col } from "react-bootstrap";
import anime from 'animejs';
import "./Persons.css";

function Persons() {
    const [isVisible, setIsVisible] = useState(false);
    const titleRef = useRef(null);
    const descriptionRef = useRef(null);
    const familyRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !isVisible) {
                    setIsVisible(true);
                    
                    // Title animation
                    anime({
                        targets: titleRef.current,
                        translateY: [50, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 200,
                    });

                    // Description animation
                    anime({
                        targets: descriptionRef.current,
                        translateY: [30, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 500,
                    });

                    // Family members animation
                    anime({
                        targets: '.family-member',
                        translateY: [50, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1000,
                        delay: anime.stagger(200),
                        begin: () => {
                            anime.set('.family-member', { opacity: 0, translateY: 50 });
                        }
                    });

                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1
        });

        observer.observe(titleRef.current);
        observer.observe(descriptionRef.current);
        observer.observe(familyRef.current);

        return () => observer.disconnect();
    }, [isVisible]);

    const familyMembers = [
        {
            name: 'Γιώργος Μαλανδρής',
            role: 'Ιδιοκτήτης',
            description: 'Με πάνω από 30 χρόνια εμπειρίας στην καλλιέργεια ελάτων',
            photo: '/images/memberIcon.png'
        },
        {
            name: 'Αργύρης Μαλανδρής',
            role: 'Διαχειριστής',
            description: 'Υπεύθυνος για τη διαχείριση και την οργάνωση του χώρου',
            photo: '/images/memberIcon.png'
        },
        {
            name: 'Σωτήρης Μαλανδρής',
            role: 'Διαχειριστής',
            description: 'Ειδικός στην καλλιέργεια και φροντίδα των ελάτων',
            photo: '/images/memberIcon.png'
        }
    ];

    return (
        <div className="persons-section" id="persons">
            <Container fluid className="px-4 px-md-5">
                <div className="persons-content">
                    <h2 className={`section-title ${isVisible ? 'visible' : ''}`} ref={titleRef}>
                        Η Οικογένειά μας
                    </h2>
                    <p className={`section-description ${isVisible ? 'visible' : ''}`} ref={descriptionRef}>
                        Τρεις γενιές εμπειρίας στην καλλιέργεια και εμπορία ελάτων από τον Ταξιάρχη Χαλκιδικής.
                        Η παράδοση και η φροντίδα περνούν από γενιά σε γενιά, εξασφαλίζοντας δέντρα μοναδικής ποιότητας.
                    </p>
                    <Row className="family-members" ref={familyRef}>
                        {familyMembers.map((member, index) => (
                            <Col key={index} md={4} className="family-member">
                                <div className="member-card">
                                    <div className="member-image">
                                        <img
                                            src={member.photo}
                                            alt={member.name}
                                            loading="lazy"
                                        />
                                    </div>
                                    <div className="member-info">
                                        <h3>{member.name}</h3>
                                        <p className="member-role">{member.role}</p>
                                        <p className="member-description">{member.description}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Container>
            <Divider/>
        </div>
    );
}

export default Persons;